export enum OverdueNoticeFeeTypeEnum {
  ABSOLUTE = 'ABSOLUTE',
  PERCENT = 'PERCENT',
}
